var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"user-pages"}},[_c('PageTitle',{attrs:{"title":"Пользователи","icon":""}}),_c('UsersList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }